import { Button, Modal, Label, TextInput, Textarea } from "flowbite-react";
import { useForm } from "react-hook-form";
import { EventType } from "@/sharedTypes";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

interface EventTypeFormDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: EventType) => void;
  defaultValues?: EventType;
  mode?: "create" | "edit";
  errorMessage?: string;
}

export default function EventTypeFormDialog({
  open,
  onClose,
  onSubmit,
  defaultValues,
  mode = "create",
  errorMessage,
}: EventTypeFormDialogProps) {
  const { t } = useTranslation(["temporalActivity", "common"]);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm<EventType>();

  useEffect(() => {
    if (open) {
      reset(
        defaultValues || {
          event_type: "",
          description: "",
        }
      );
    }
  }, [open, defaultValues, reset]);

  return (
    <Modal show={open} onClose={onClose}>
      <Modal.Header>
        {mode === "edit" ? t("temporalActivity:eventType.edit") : t("temporalActivity:eventType.create")}
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <div>
            <div className="mb-2 block">
              <Label htmlFor="event_type" value={t("temporalActivity:eventType.name")} />
            </div>
            <TextInput
              id="event_type"
              placeholder={t("temporalActivity:eventType.namePlaceholder")}
              {...register("event_type", {
                required: t("temporalActivity:eventType.nameRequired") as string,
              })}
              color={errors.event_type ? "failure" : "gray"}
              helperText={errors.event_type?.message}
            />
          </div>

          <div>
            <div className="mb-2 block">
              <Label htmlFor="description" value={t("temporalActivity:eventType.description")} />
            </div>
            <Textarea
              id="description"
              placeholder={t("temporalActivity:eventType.descriptionPlaceholder")}
              {...register("description")}
            />
          </div>

          {errorMessage && <div className="text-sm text-red-500">{errorMessage}</div>}

          <div className="flex justify-end gap-x-2">
            <Button color="gray" onClick={onClose}>
              {t("common:cancel")}
            </Button>
            <Button type="submit" disabled={isSubmitting}>
              {mode === "edit" ? t("common:save") : t("common:create")}
            </Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}
